import { SearchBarAction } from 'labstep-web/components/FilterPost';
import { useExportProgressContext } from './context';
import type { DataGridExportAsCSVProps } from './types';

export const DataGridExportAsCSV: React.FC<
  DataGridExportAsCSVProps
> = ({ className }) => {
  const { exportProgress, handleExport } = useExportProgressContext();

  return (
    <SearchBarAction
      text="Export"
      icon="download"
      disabled={exportProgress.isExporting}
      onClick={handleExport}
      className={className}
    />
  );
};
